import { useEffect, useState } from 'react';
import { Box, CircularProgress, Grid, Paper, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { Layout, Loading, UserNavbar } from '../../../../../components';
import PendingCard from './PendingCard';
import * as VenueActions from '../../../../../core/venues/action';
import { VENUE_STATUS } from '../../../../../constants/venue-status';

const inputStyles = {
  backgroundColor: '#fffdfd98',
  borderRadius: 50,
  width: '100vw',
  height: 95,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  color: '#EE7B57',
};

function PendingVenues(props) {
  const dispatch = useDispatch();
  const { venueList, loading } = useSelector((store) => store.venues);
  const [pendingVenues, setPendingVenues] = useState();

  useEffect(() => {
    dispatch(VenueActions.getVenues());
  }, [dispatch]);

  useEffect(() => {
    setPendingVenues(venueList && venueList.filter((v) => v.status === VENUE_STATUS.PENDING));
  }, [venueList]);

  const output = () => {
    if (loading)
      return (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <CircularProgress size={40} />
        </Box>
      );
    if (pendingVenues && pendingVenues.length > 0)
      return pendingVenues.map((v) => <PendingCard key={v.id} venue={v} />);
    return 'No venues';
  };

  return (
    <Layout>
      <UserNavbar />
      <Grid container justifyContent="center" marginTop={30}>
        <Grid item xs={9} style={inputStyles} marginBottom={3}>
          <h1>Pending venues registrations</h1>
        </Grid>
        <Paper sx={{ backgroundColor: '#FCE5DD', p: 3, mb: 2, width: '70%', borderRadius: '50px' }}>
          {output()}
        </Paper>
      </Grid>
    </Layout>
  );
}

PendingVenues.propTypes = {};

export default PendingVenues;
